import React from 'react';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import CreditUsageModuleView from './CreditUsageModuleView';

export const CreditUsageModuleController = props => {
  const loading = props?.globalLoadingFlag;
  const { creditUsageSummary } = props?.additionalData;

  if (loading) {
    return <LoadingMask />;
  } else {
    return <CreditUsageModuleView creditUsageSummary={creditUsageSummary} />;
  }
};
